import { LRUCache } from 'src/common/utils/lru-cache';

import type { PDFPreviewStatus } from '../type';

export const pdfPreviewCache = new LRUCache<string, PDFPreviewStatus>(
  localStorage,
  'pdfPreviewStatus',
  50
);
